import React, { useState } from 'react';
import { ValidationProps } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { SelectMultiple, SelectMultipleHierarchy } from 'app/area/shared/translated-components';

import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

interface ReportCodeProps {
  id: string;
  label: string;
  isHierarchy: boolean;
  values: ComplexValue<number>[];
  onChange: (values: ComplexValue<number>[]) => void;

  optionsEndpoint: string;
  options: {
    fetching: boolean;
    codes?: ComplexValue<number | string>[];
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  validation: ValidationProps;
  searchLabel: string;

  manageOptionsId?: number;
  manageOptionsLabel?: string;

  locale: string;
}

export const ReportCode: React.FC<ReportCodeProps> = ({
  id, label, isHierarchy, values, onChange,
  optionsEndpoint, options, loadOptions,
  validation, searchLabel,
  manageOptionsId, manageOptionsLabel, locale
}) => {

  const [codeOptions, setCodeOptions] = useState<LoadOptions>();

  const onCodeLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(id, optionsEndpoint, loadOptionsParams);
    setCodeOptions(loadOptionsParams);
  };

  const Component = isHierarchy ? SelectMultipleHierarchy : SelectMultiple;
  const additionalProps = isHierarchy ? {
    descriptionAllLevels: true
  } : {};

  return <Component
    componentId={id}
    className={undefined}
    label={label ? { text: label } : undefined}
    valueItems={values || []}
    onChange={onChange}
    validation={validation}
    placeholder={searchLabel}
    extraFooterButton={isDefinedIncludingZero(manageOptionsId)
      ? manageOptionsButton(manageOptionsLabel, manageOptionsId)
      : undefined}

    options={options?.codes as ComplexValue<number>[] || []}
    fetching={options?.fetching || false}
    loadOptions={codeOptions}
    onLoadOptions={onCodeLoadOptions}
    locale={locale}

    displaySelectAll={true}

    {...additionalProps} />;
};
